var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKeyUserAktiv != null)?_c('span',{staticClass:"keyUserAktivWrapper"},[(_vm.isKeyUserAktiv)?_c('b-icon',{staticStyle:{"color":"green"},attrs:{"icon":"check"}}):_c('b-icon',{staticStyle:{"color":"red"},attrs:{"icon":"exclamation-triangle"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }